export default __webpack_public_path__ + "instagram-sqr-v1.svg";